import PlaidBaseComponent from '~/javascripts/components/PlaidBaseComponent';
import store from '~/javascripts/store.js';
import { Component } from 'react';
import { observer } from 'mobx-react';
import { pauseForSpecs } from '~/javascripts/utils/testing';

const DonateFormPlaidComponent = observer(
  class DonateFormPlaidComponent extends Component {
    onSuccess = (publicToken, metadata) => {
      store.donateForm.disableFormSubmit = true;
      store.donateForm.last4 = metadata.account.mask;
      store.donateForm.plaidAccountId = metadata.account.id;
      store.donateForm.plaidToken = publicToken;

      store.donateForm.createDonationForm('ach', (response) => {
        pauseForSpecs(() => {
          if (store.donateForm.embedded) {
            store.donateForm.step = 'embed-success';
          } else {
            window.location = response.redirectUrl;
          }
        });
      });
    };

    onExit = () => {
      store.donateForm.disableFormSubmit = false;
    };

    render() {
      return (
        <span
          className='ach-base-component'
          ref={(el) => (this.plaidComponentWrapper = el)}
        >
          <PlaidBaseComponent
            onExit={this.onExit}
            onSubmitClick={this.props.onSubmitClick}
            onSuccess={this.onSuccess}
            plaidEnv={store.donateForm.plaidEnv}
          >
            {this.props.children}
          </PlaidBaseComponent>
        </span>
      );
    }
  }
);

export default DonateFormPlaidComponent;
